import { FC } from "react";
import { Button, Typography } from "@mui/material";

import Row from "../../../ui/core/Row";

interface UnansweredMessageNoticeProps {
  /** Absent while the message may still be on its way: shows "Still sending…". */
  onRetry?: () => void;
}

/** Under a message the backend saved but never sent to the agent (REV-2553). */
const UnansweredMessageNotice: FC<UnansweredMessageNoticeProps> = ({ onRetry }) => (
  <Row
    data-testid="unanswered-message-notice"
    sx={{
      alignItems: "center",
      justifyContent: "flex-end",
      gap: 1.5,
      maxWidth: "60rem",
      width: "100%",
      marginRight: "auto",
      marginLeft: "auto",
      marginTop: "-15px",
      marginBottom: "25px",
    }}
  >
    <Typography variant="body2" color="text.secondary">
      {onRetry ? "This message wasn't processed." : "Still sending…"}
    </Typography>
    {onRetry && (
      <Button size="small" variant="outlined" color="primary" onClick={onRetry}>
        Retry
      </Button>
    )}
  </Row>
);

export default UnansweredMessageNotice;
